import { OnDestroy, OnInit, } from '@angular/core';
import { FormBuilder, FormControl, Validators, } from '@angular/forms';
import { ActivatedRoute, Router, } from '@angular/router';
import { AppStateFacade } from '@app-state';
import { AuthService } from '@services';
import { unsubscribe } from '@utils/object.utils';
import UiValidators, { UI_EMAIL_MAX_LENGTH, UI_NAME_LONG_MAX_LENGTH, UI_NAME_MAX_LENGTH, UI_PASSWORD_MAX_LENGTH, } from '@validators';
import { BehaviorSubject, combineLatest, } from 'rxjs';
import { finalize, switchMap, tap, } from 'rxjs/operators';
var RegisterTenantPageComponent = /** @class */ (function () {
    function RegisterTenantPageComponent(_route, _router, _authService, _fb, _appState) {
        this._route = _route;
        this._router = _router;
        this._authService = _authService;
        this._fb = _fb;
        this._appState = _appState;
        this.loading$ = new BehaviorSubject(false);
        this.authConfig$ = this._appState.authConfig.value$;
    }
    RegisterTenantPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._routeSub =
            combineLatest([
                this._route.queryParams
                    .pipe(tap(function (result) {
                    _this.registrationType = result['type'];
                    _this._initFormGroup();
                })),
                this._authService.getExternalLoginInfo(),
            ])
                .subscribe(function (_a) {
                var _ = _a[0], data = _a[1];
                if (_this.registrationType === 'external') {
                    if (data) {
                        _this.form.get('TenancyName').patchValue(data.tenancyName);
                        _this.form.get('EmailAddress').patchValue(data.emailAddress);
                        _this.form.get('Name').patchValue(data.name);
                        _this.form.get('Surname').patchValue(data.surname);
                        _this.form.get('RegistrationType').patchValue(_this.registrationType);
                    }
                }
                else {
                    _this.form.get('Password').setValidators(Validators.compose([
                        Validators.required,
                        Validators.maxLength(UI_PASSWORD_MAX_LENGTH),
                        UiValidators.complexity(_this._appState.authConfig.value.passwordComplexity),
                    ]));
                    _this.form.get('ConfirmPassword').setValidators(Validators.compose([
                        Validators.required,
                        Validators.maxLength(UI_PASSWORD_MAX_LENGTH),
                    ]));
                }
            });
    };
    RegisterTenantPageComponent.prototype.ngOnDestroy = function () {
        unsubscribe(this._routeSub);
    };
    RegisterTenantPageComponent.prototype.onSubmit = function (event) {
        var _this = this;
        event.preventDefault();
        if (!this.form.valid) {
            return;
        }
        this.loading$.next(true);
        this._authService.registerTenant(this.form.value)
            .pipe(finalize(function () { return _this.loading$.next(false); }), tap(function () { return _this._authService.lastTenantUsed = _this.form.get('TenancyName').value; }), switchMap(function () { return _this._appState.user.fetch(); }), switchMap(function () { return _this._appState.user.ensureCorrectIdentity(); }))
            .subscribe(function () { return _this._router.navigate(['/']); });
    };
    RegisterTenantPageComponent.prototype._initFormGroup = function () {
        this.form = this._fb.group({
            'TenancyName': ['', Validators.compose([
                    Validators.maxLength(UI_NAME_LONG_MAX_LENGTH),
                    UiValidators.regex('^[\\p{L}][\\p{L}0-9-_]+$'),
                ])],
            'UserName': ['admin', UiValidators.required()],
            'Name': ['', Validators.compose([
                    Validators.required,
                    Validators.maxLength(UI_NAME_MAX_LENGTH),
                ])],
            'Surname': ['', Validators.compose([
                    Validators.required,
                    Validators.maxLength(UI_NAME_MAX_LENGTH),
                ])],
            'EmailAddress': ['', Validators.compose([
                    UiValidators.email(true),
                    Validators.maxLength(UI_EMAIL_MAX_LENGTH),
                ])],
            'RegistrationType': ['internal'],
            'Password': [''],
            'ConfirmPassword': [''],
        }, {
            validator: UiValidators.confirmPassword('Password', 'ConfirmPassword'),
        });
        if (this._appState.authConfig.value.application.termsAndConditionsRegisterUrl) {
            var termsControl = new FormControl(false, UiValidators.regex(/^true$/));
            this.form.addControl('TermsAndConditionsAccepted', termsControl);
        }
        if (!this._appState.authConfig.value.application.isTenantRegistrationEnabled) {
            // go to dashboard if registration is disabled
            this._router.navigate(['/']);
        }
    };
    return RegisterTenantPageComponent;
}());
export { RegisterTenantPageComponent };
